import { Injectable } from '@angular/core';
import { AppService } from '../../core/service/Base.Service';
import { DataTransferObject } from '../../core/entities/DataTransferObject';

@Injectable()
export class RelationTypeService extends AppService<any> {

    constructor() {
        super('Relationtype');
    }

     async getRelationType() {
        const result = await this.get('');
        return result;
    }

}





// WEBPACK FOOTER //
// ./src/app/shell/shared/relationtype.service.ts